// Button style A — "expanding circle" (text actions) and its small arrow chip.
import i18n from '@/i18n';
import type { MouseEventHandler, ReactNode } from 'react';
import { Link } from 'react-router';
import { cx } from '@/lib/format';
import { ChevArrow } from './Icon';

type XButtonProps = {
  label: ReactNode;
  to?: string;
  inv?: boolean;
  sm?: boolean;
  busy?: boolean;
  id?: string;
  className?: string;
  type?: 'button' | 'submit';
  onClick?: MouseEventHandler<HTMLElement>;
};

/** Dark circle with › next to the label; on hover the circle stretches into a pill. */
export function XButton({ label, to, inv, sm, busy, id, className, type = 'button', onClick }: XButtonProps) {
  const cls = cx('xbtn', inv && 'inv', sm && 'sm', busy && 'busy', className);
  const inner = (
    <>
      <span className="xb-c"><ChevArrow /></span>
      <span className="xb-t">{label}</span>
    </>
  );
  return to
    ? <Link className={cls} to={to} id={id} onClick={onClick}>{inner}</Link>
    : <button className={cls} type={type} id={id} onClick={onClick}>{inner}</button>;
}

/** Small "→" circle in tile/card corners that opens into a label on hover. */
export function ArrowChip({ label = i18n.t('common:action.open') }: { label?: string }) {
  return (
    <span className="ab">
      <em>{label}</em>
      <i><ChevArrow /></i>
    </span>
  );
}

/** Lower-section header link: inverted small XButton. */
export const LinkButton = ({ to, label = i18n.t('common:action.open') }: { to: string; label?: string }) => <XButton label={label} to={to} inv sm />;
